
import { useStore } from '@/store';
import { Actions } from '@/store/Actions';
import { computed, ComputedRef, defineComponent, reactive } from 'vue';
import UseIcon from '../UseIcon/UseIcon.vue';

type State = {
    feedback: string;
    isLoading: boolean;
    hasError: boolean | null;
};

interface SetupReturn {
    state: State;
    submitButtonIsDisabled: ComputedRef<boolean>;
    submitFeedback(): Promise<void>;
}

export default defineComponent({
    components: { UseIcon },
    setup(): SetupReturn {
        const store = useStore();
        const state = reactive<State>({
            feedback: '',
            isLoading: false,
            hasError: null,
        });
        const submitButtonIsDisabled = computed<boolean>(() => {
            return !state.feedback.length;
        });
        const handleError = () => {
            state.hasError = true;
            state.isLoading = false;
        };

        const submitFeedback = async (): Promise<void> => {
            try {
                state.isLoading = true;
                await store.dispatch(Actions.SAVE_FEEDBACK, state.feedback);
            } catch (error) {
                handleError();
            } finally {
                state.isLoading = false;
            }
        };

        return {
            state,
            submitButtonIsDisabled,
            submitFeedback,
        };
    },
});
